import { StormWatchWidget } from "@/components/dashboard/StormWatchWidget";

export default function StormMap() {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Storm Watch</h1>
        <p className="text-muted-foreground">Monitor weather conditions and hail risk in your area</p>
      </div>
      <StormWatchWidget />
    </div>
  );
}
